import type { CenterProps, IconProps } from '@chakra-ui/react';
import { Center, Icon } from '@chakra-ui/react';

interface ButtonTagProps extends CenterProps {
  iconProps?: IconProps;
}

export const MobileWalletButtonTag = ({
  children,
  iconProps,
  ...containerProps
}: ButtonTagProps) => {
  return (
    <Center
      position="absolute"
      top={1}
      right={1}
      zIndex={1}
      boxSize={5}
      {...containerProps}
    >
      <Icon boxSize="100%" {...iconProps}>
        {children}
      </Icon>
    </Center>
  );
};
